import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <p className="mb-4">
        We may collect personal information such as your name, email address,
        and usage data when you use our website or services.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Information</h2>
      <p className="mb-4">
        We use the collected information to provide, operate, and maintain our
        services; improve your experience; communicate with you; and comply
        with legal obligations.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Sharing</h2>
      <p className="mb-4">
        We do not share your personal data with third parties except when
        necessary to provide our services, comply with the law, or protect our
        rights.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
      <p className="mb-4">
        We take appropriate measures to protect your data against unauthorized
        access, alteration, disclosure, or destruction.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
      <p className="mb-4">
        You have the right to access, update, or delete your personal
        information. You can contact us to exercise these rights.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Changes to This Policy</h2>
      <p className="mb-4">
        We may update our Privacy Policy from time to time. Changes will be
        posted on this page with an updated revision date.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.Your privacy is important to us. It is our policy to respect your
        privacy regarding any information we may collect from you across our
        website and other sites we own and operate.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact Us</h2>
      <p className="mb-4">
        If you have any questions about our privacy practices, please contact
        us at <a href="mailto:support@example.com" className="text-blue-600 underline">support@example.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
